module.exports = __webpack_public_path__ + "static/media/icon_list.37513de3.svg";